import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

import React, { memo, useMemo } from "react";

import CustomSnackbar from ".";
import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import Box from "../Box";
import Typography from "../Typography";
import SnackbarIconRoot from "./SnackbarIconRoot";

export interface IMessageFirebase {
    messageId?: string;
    data?: {
        Title?: string;
        Body?: string;
    };
}

type IColor = "primary" | "secondary" | "info" | "success" | "warning" | "error" | "dark";

export interface ISnackbarMessageProps {
    bgWhite?: boolean;
    dataMessage?: IMessageFirebase;
    autoHideDuration?: number;
    onClose?: () => void;
    onNavigate?: (data: { type?: any; id?: string }) => void;
    color?: IColor;
}

const SnackbarMessage: React.FC<ISnackbarMessageProps> = ({
    color,
    bgWhite,
    onClose,
    onNavigate,
    dataMessage,
    autoHideDuration,
}: ISnackbarMessageProps) => {
    const strings = useStrings();
    // const [controller] = useMaterialUIController();
    // const { darkMode } = controller;

    const isShowSnackbar = useMemo(() => {
        if (!Helpers.isNullOrEmpty(dataMessage?.messageId)) {
            return true;
        } else {
            return false;
        }
    }, [dataMessage?.messageId]);

    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }
        Helpers.isFunction(onClose) && onClose();
    };

    if (Helpers.isNullOrEmpty(dataMessage?.messageId)) return null;

    return (
        <CustomSnackbar
            open={isShowSnackbar}
            autoHideDuration={!Helpers.isNullOrEmpty(autoHideDuration) ? autoHideDuration : 5000}
            onClose={(event: any, reason: any) => handleClose(event, reason)}
        >
            <Box
                p={1}
                shadow="md"
                maxWidth="100%"
                borderRadius="md"
                minWidth="21.875rem"
                // bgColor={bgWhite ? "white" : color}
                variant={bgWhite ? "contained" : "gradient"}
                onClick={() => {
                    Helpers.isFunction(onClose) && onClose();
                    // Helpers.isFunction(onNavigate) && onNavigate({type: 0, id: ""});
                }}
                sx={({ palette, functions: { rgba } }) => ({
                    border: "1px solid transparent",
                    borderColor: palette[color]?.main,
                    backgroundColor: rgba(palette[color]?.main, 0.1),
                })}
            >
                <Box p={1.5} color="dark" display="flex" alignItems="center" justifyContent="space-between">
                    <Box display="flex" alignItems="center" lineHeight={0}>
                        <SnackbarIconRoot fontSize="small" ownerState={{ color, bgWhite }}>
                            {"notifications"}
                        </SnackbarIconRoot>
                        <Typography variant="button" fontWeight="medium" color={color} textGradient={bgWhite}>
                            {dataMessage?.data?.Title || strings.Common.NOTIFICATION}
                        </Typography>
                    </Box>
                    <Box display="flex" alignItems="center" lineHeight={0}>
                        <Icon
                            onClick={handleClose}
                            sx={({ palette }) => ({
                                // color: ({ palette: { dark, white } }) => ((bgWhite && !darkMode) || color === "light" ? dark.main : white.main),
                                fontWeight: ({ typography: { fontWeightBold } }) => fontWeightBold,
                                color: palette[color].main,
                                marginLeft: 2,
                                cursor: "pointer",
                                transform: "translateY(-1px)",
                                WebkitTextFillColor: palette[color].main,
                                WebkitBackgroundClip: "text",
                            })}
                        >
                            close
                        </Icon>
                    </Box>
                </Box>
                <Divider sx={{ margin: 0 }} />
                <Box
                    p={1.5}
                    sx={{
                        width: "21.875rem",
                        fontSize: ({ typography: { size } }) => size.sm,
                    }}
                >
                    <Box
                        sx={({ palette, functions: { rgba } }) => ({
                            WebkitLineClamp: 2,
                            overflow: "hidden",
                            verticalAlign: "unset",
                            textDecoration: "none",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            color: rgba(palette[color].main, 1),
                        })}
                    >
                        {dataMessage?.data?.Body || ""}
                    </Box>
                </Box>
            </Box>
        </CustomSnackbar>
    );
};

// Setting default values for the props of SnackbarMessage
SnackbarMessage.defaultProps = {
    bgWhite: false,
    color: "info",
};

export default memo(SnackbarMessage);
